var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Anchor from '@telia-front/anchor';
import Icon from '@telia-front/icon';
import { ListItem } from '@telia-front/list';
import { ArrowListContext } from '../index';
const ArrowListItem = (props) => {
    var _a, _b;
    const context = React.useContext(ArrowListContext);
    const color = (_a = props.color) !== null && _a !== void 0 ? _a : context.purpose;
    const theme = context.theme;
    const large = context.large;
    const hover = context.backgroundHover;
    const iconClassName = (_b = props.iconClassName) !== null && _b !== void 0 ? _b : context.iconClassName;
    const { showArrow = true } = props, rest = __rest(props, ["showArrow"]);
    const listItemBem = () => {
        const classArray = [`arrow-list__item ${large && getHeaderBackgroundColor()}`];
        if (props.className) {
            classArray.push(props.className);
        }
        if (hover) {
            classArray.push('arrow-list__item--hover');
        }
        return classArray.join(' ');
    };
    const iconBEM = () => {
        const classArray = ['arrow-list__icon'];
        if (iconClassName) {
            classArray.push(iconClassName);
        }
        return classArray.join(' ');
    };
    const getHeaderBackgroundColor = () => {
        switch (context.backgroundColor) {
            case 'beige':
                return 'bg-background-4';
            case 'white':
                return 'bg-primary-4';
            default:
                return 'bg-neutral-1';
        }
    };
    return (React.createElement(ListItem, Object.assign({}, rest, { className: listItemBem(), iconClassName: iconBEM() }),
        React.createElement(Anchor, Object.assign({ isUnderlined: false }, rest, { isTextColor: !color, color: color, className: "arrow-list__link", theme: !color ? theme : undefined }),
            React.createElement("div", { className: "arrow-list__content" },
                React.createElement("div", { className: "arrow-list__inner" }, props.children),
                showArrow && (React.createElement(Icon, { size: large ? 'sm' : 'xs', modifiers: "#arrow-right", className: "arrow-list__arrow-icon" }))))));
};
export { ArrowListItem as default, };
